import Vue from "vue";
import moment from "moment";

Vue.filter("formatDateHourly", function (value) {
  if (value && value !== "0001-01-01T00:00:00") {
    return moment(String(value)).format("HH:mm");
  } else {
    return "--:--";
  }
});

Vue.filter("formatDateHourlyWithDay", function (value) {
  if (value && value !== "0001-01-01T00:00:00") {
    return moment(String(value)).format("D/HH:mm");
  } else {
    return "--:--";
  }
});

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("ddd DD-MM");
  }
});
Vue.filter('formatDateToISO', function(value) {
  if (value) {
    return moment(String(value)).toISOString();
  }
});
Vue.filter("formatPhoneEmail", function (value) {
  if (value) return value;
  return "--";
});
export default Vue;
